declare const $: any;
declare const document: any;

const EVENT_NAMESPACE = '.qaDragulaScroll';
let container: any = null;
let win: any = null;
let latestClientY: number | null = null;
let rafId: number | null = null;
let isActive = false;

const applyScroll = () => {
  rafId = null;

  if (!isActive || latestClientY === null || !container || !win) {
    return;
  }

  const height = win.height();
  const top = win[0]?.getBoundingClientRect ? win[0].getBoundingClientRect().top : 0;
  const edge = 64;
  const y = latestClientY - top;
  const distance = y < edge ? -Math.min(16, (edge - y) / 4)
    : y > height - edge ? Math.min(16, (y - height + edge) / 4) : 0;
  if (distance === 0) {
    return;
  }
  const before = container.scrollTop();
  container.scrollTop(before + distance);
  // Continue at the edge while holding the pointer still, until the scroll limit.
  if (container.scrollTop() !== before) {
    rafId = requestAnimationFrame(applyScroll);
  }
};

const onMouseMove = (e) => {
  latestClientY = e.clientY;

  if (rafId !== null) {
    return;
  }

  rafId = requestAnimationFrame(applyScroll);
};

export const dragulaScroll = function() {
  if (isActive) {
    return;
  }

  isActive = true;

  // use document and window as container
  container = $(document);
  win = $(window);

  /**
   * When the editor is maximized, we have to use the editor element instead of the document element,
   * as it is set to overlay the document. Thus scrolling the document would not really make any sense ;p
   */
  if ($('.qa-editor.maximized').length) {
    container = $('.qa-editor.maximized');
    win = $('.qa-editor.maximized');
  }

  /**
   * In the app layout only the document column scrolls, so dragging towards its edges scrolls the document
   */
  const pane = $('.qa-app-layout .qa-document-scroll');
  if (pane.length) {
    container = pane;
    win = pane;
  }

  /**
   * Registers a handler for the "mouse move" event. Scrolls the editor by the mouse position
   */
  $(document).on(`mousemove${EVENT_NAMESPACE}`, onMouseMove);
};

export const dragulaScrollStop = function() {
  isActive = false;
  latestClientY = null;
  $(document).off(`mousemove${EVENT_NAMESPACE}`, onMouseMove);

  if (rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
};
